<template>
  <highcharts
    ref="chart"
    :options="options"
  ></highcharts>
</template>

<script>
import { Chart } from "highcharts-vue";
import Highcharts from "highcharts";

export default {
  components: {
    highcharts: Chart,
  },
  props: {
    options: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      chart: null,
    };
  },
  mounted() {
    this.chart = this.$refs.chart.chart;
  },
  computed: {},
  watch: {
    chart() {
      this.chart.xAxis[0].update({
        events: {
          afterSetExtremes: this.afterSetExtremes,
        },
      });
      // console.log(chart);
    },
  },
  methods: {
    afterSetExtremes(event) {
      this.$emit("afterSetExtremes", this.chart);
    },
  },
};
</script>

<style scoped>
.chart {
  /* max-height: 280px; */
}
</style>